$(document).ready(function () {
  // Função para obter o valor do localStorage
  function getLocalStorageItem(key) {
      return localStorage.getItem(key);
  }
  
  // Função para definir um item no localStorage
  function setLocalStorageItem(key, value) {
      localStorage.setItem(key, value);
  }
  
  // Função para limpar o carrinho da loja Shopify
  function clearShopifyCart() {
      fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
      })
      .then(response => response.json())
      .then(data => {
          console.log('Carrinho limpo com sucesso!', data);
          window?.reloadCart();
      })
      .catch(error => {
          console.error('Erro ao limpar o carrinho:', error);
      });
  }
  
  // Função principal
  function checkAndSetVipTheme() {
      // Verifica se o item 'defaultTheme' existe no localStorage
      const defaultThemeLocalStorage = getLocalStorageItem('defaultTheme');
  
      if (!defaultThemeLocalStorage) {
          // Se o item não estiver presente, limpa o carrinho
          clearShopifyCart();

          // Verifica se o item 'viptheme' existe no localStorage e remove, se necessário
          const vipThemeLocalStorage = getLocalStorageItem('viptheme');
          if (vipThemeLocalStorage) {
              localStorage.removeItem('viptheme');
              console.log('Item "viptheme" removido do localStorage.');
          }
  
          // Define o item 'defaultTheme' no localStorage para o usuário
          setLocalStorageItem('defaultTheme', 'true');
  
          console.log('Item "defaultTheme" definido no localStorage e carrinho limpo.');
      } else {
          console.log('Item "defaultTheme" já está definido no localStorage.');
      }
  }
  
  // Chama a função
  checkAndSetVipTheme();

  
  function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();

    $("body").append($temp);
    $temp.val($(element).html()).select();
    document.execCommand("copy");
    $(element).html("COPIADO");
    setTimeout(function () {
      $(element).html(oldValue);
    }, 300);
    $temp.remove();
  }

  $("cupom").click(function () {
    copyToClipboard(this);
  });


  
  // Decrease item quantity
  $(document).on("click", ".grid-qtt.minus", function (e) {
    e.preventDefault();
    var input = $(this).next();
    var currentValue = parseInt(input.val());
    if (currentValue > 1) {
      input.val(currentValue - 1);
    }
  });

  // Increase item quantity
  $(document).on("click", ".grid-qtt.plus", function (e) {
    e.preventDefault();
    var input = $(this).prev();
    var currentValue = parseInt(input.val());
    var maxQuantity = parseInt(input.attr("max"));
    // log those values
    console.log(currentValue, maxQuantity);
    if (currentValue < maxQuantity || maxQuantity != 0) {
      input.val(currentValue + 1);
    }
  });

  $(document).on('click', '[add-to-cart-express]', function(event){
    event.preventDefault();
    let formData = {
     'items': [{
      'id': parseInt($(this).attr('add-to-cart-express')),
      'quantity': 1
      }]
    };
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      document.dispatchEvent(new CustomEvent('cart-update', { detail: { ...response, eventName: 'add_to_cart' } }))
      window.updateCart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    
    // $.ajax({
    //     type: "post",
    //     url: "/cart/add.js",
    //     body: JSON.stringify(formData),
    //     dataType: 'json',
    
    //     beforeSend: function () {},
    
    //     success: function (msg) {
    //       document.dispatchEvent(new CustomEvent('cart-update', { detail: { ...msg, eventName: 'add_to_cart' } }))
    //       window.updateCart();
    //     },
    
    //     error: function (xhr, text) {
    //         alert($.parseJSON(xhr.responseText).description);
    //     }
    // });
  })

  // UPSELL Carrinho
  window.upsellSliderInit = function () {
    // $(".recommend-slider .swiper-wrapper").slick({
    //   slidesToShow: 3,
    //   slidesToScroll: 3,
    //   variableWidth: true,
    //   dots: true,
    //   infinite: false,
    //   arrows: true,
    //   prevArrow: ".swiper-button-prev",
    //   nextArrow: ".swiper-button-next",
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         variableWidth: true,
    //         centerMode: false,
    //       },
    //     },
    //   ],
    // });

    $(".recommend-container").addClass("loaded");
  };

  function beforeSend(element) {
    $("#dropdown-cart").addClass("updating-cart");
    $(element).find(".recommend-btn-add").addClass("is-loading");
  }

  function afterSend(element) {
    $("#dropdown-cart").removeClass("updating-cart");
    $(element).find(".recommend-btn-add").removeClass("is-loading");
  }

  $(document).on("submit", ".upsell-form", function (e) {
    e.preventDefault();

    const formData = new FormData(this);
    const serializedData = {};
    formData.forEach((value, key) => {
      serializedData[key] = value;
    });
    const jsonData = JSON.stringify(serializedData);

    // URL da API da Shopify para adicionar um item ao carrinho
    const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

    // Opções da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonData,
    };

    beforeSend(e.target); // Ação "before send" antes da requisição

    // Faz a requisição usando fetch com ação "before send" e "after send"
    fetch(addToCartUrl, requestOptions)
      .then((response) => {
        afterSend(); // Ação "after send" após a conclusão da requisição

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui
        Shopify.getCart(window.updateCart);
        $("body").addClass("cart-sidebar-show");
      })
      .catch((error) => {
        // Houve um erro na requisição, você pode tratar o erro aqui
        console.error("Error:", error);
      });
  });

  $(document).on("change", ".variants-product-selects select", function () {
    var $currentSelect = $(this);
    var $nextSelect = $currentSelect
      .closest(".variants-product-selects")
      .find("select")
      .eq($currentSelect.index() + 1);

    if ($nextSelect.length && $nextSelect.is(":hidden") && $nextSelect.find('option').length > 1) {
      $nextSelect.show();
    } else{
      var selectedOptions = $currentSelect
        .closest(".variants-product-selects")
        .find("select")
        .map(function () {
          return $(this).val();
        })
        .get();
      var productData = JSON.parse(
        $currentSelect
          .closest(".infoProduct")
          .find("[data-json-product]")
          .text()
      );

      var matchingVariant = productData.find(function (variant) {
        return selectedOptions.every(function (option, index) {
          return variant.options[index] === option;
        });
      });

      if (matchingVariant && matchingVariant.available) {
        $currentSelect
          .closest(".infoProduct")
          .find(".variantIdAddCart")
          .val(matchingVariant.id);
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .prop("disabled", false);
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .val("ADICIONAR");
      } else {
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .prop("disabled", true);
        $currentSelect
          .closest(".infoProduct")
          .find(".recommend-btn-add")
          .val("ESGOTADO");
        console.log("Produto esgotado");
      }
    }

    var container = $(".halo-cart-sidebar").find(".previewCart");
    var scrollTo = $(".halo-cart-sidebar").find(".recommend-container");

    // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
    var scrollPosition =
      scrollTo.offset().top +
      scrollTo.outerHeight() +
      container.scrollTop() -
      container.position().top;

    // Realiza a rolagem
    container.animate(
      {
        scrollTop: scrollPosition,
      },
      1000
    ); // 1000 milissegundos para a animação de rolagem
  });
});

(function ($) {
  let searchParams = new URLSearchParams(window.location.search);
  let cartOpen = searchParams.has("cart_show");

  if (cartOpen) {
    $(document.body).addClass("cart-sidebar-show");
  }

  function error_ship_ajax(msg) {
    var $input_cep = $(".zipcode-input"),
      $input_container = $(".cart-drawer__footer__row"),
      $erro_ship = $(".erro-shipping");

    $input_cep.val("");
    $input_container.addClass("error-input");
    $erro_ship.addClass("show");

    // if (msg.length > 0) {
    //     $erro_ship.html(msg + " Não encontrou um frete? Entre em contato por nosso whatsapp.");
    // }
    setTimeout(function () {
      $input_container.removeClass("error-input");
      $erro_ship.removeClass("show");
      // $erro_ship.html("");
    }, 4000);
  }

  function shipping_ajax() {
    var $input_cep = $(".zipcode-input"),
      $btn_calc = $(".calculate-shipping"),
      $shipping_list = $(".shipping_options__list"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $container_ship_name = $(".shipping-rate-name");


    $btn_calc.addClass("is-loading");
    var $cep = $input_cep.val().replace(/\D/g, "");
    var $validacep = /^[0-9]{8}$/;

    console.log($validacep.test($cep));
    if ($cep == "") {
      error_ship_ajax("Campo cep está vazio");
      $btn_calc.removeClass("is-loading");
      return;
    }

    if (!$validacep.test($cep)) {
      error_ship_ajax("Cep inválido");
      $btn_calc.removeClass("is-loading");
      return;
    }

    function isDateBeforeToday(date) {
      return (
        new Date(date.toDateString()) < new Date(new Date().toDateString())
      );
    }

    function excludeDate(name) {
      var response =
        name !=
          "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis" &&
        name != "Entrega Rápida - pedidos chegam em até 48hrs úteis";
      return response;
    }

    $.getJSON(
      "https://viacep.com.br/ws/" + $cep + "/json/?callback=?",
      function (dados) {
        if ("erro" in dados) {
          console.log("Erro na consulta, confira o cep e tente novamente");
          return;
        }

        switch (dados.uf) {
          case "AC":
            dados.uf = "Acre";
            break;
          case "AL":
            dados.uf = "Alagoas";
            break;
          case "AP":
            dados.uf = "Amapa";
            break;
          case "AM":
            dados.uf = "Amazonas";
            break;
          case "BA":
            dados.uf = "Bahia";
            break;
          case "CE":
            dados.uf = "Ceara";
            break;
          case "DF":
            dados.uf = "Distrito Federal";
            break;
          case "ES":
            dados.uf = "Espirito Santo";
            break;
          case "GO":
            dados.uf = "Goias";
            break;
          case "MA":
            dados.uf = "Maranhao";
            break;
          case "MT":
            dados.uf = "Mato Grosso";
            break;
          case "MS":
            dados.uf = "Mato Grosso do Sul";
            break;
          case "MG":
            dados.uf = "Minas Gerais";
            break;
          case "PA":
            dados.uf = "Para";
            break;
          case "PB":
            dados.uf = "Paraiba";
            break;
          case "PR":
            dados.uf = "Parana";
            break;
          case "PE":
            dados.uf = "Pernambuco";
            break;
          case "PI":
            dados.uf = "Piaui";
            break;
          case "RJ":
            dados.uf = "Rio de Janeiro";
            break;
          case "RN":
            dados.uf = "Rio Grande do Norte";
            break;
          case "RS":
            dados.uf = "Rio Grande do Sul";
            break;
          case "RO":
            dados.uf = "Rondonia";
            break;
          case "RR":
            dados.uf = "Roraima";
            break;
          case "SC":
            dados.uf = "Santa Catarina";
            break;
          case "SP":
            dados.uf = "Sao Paulo";
            break;
          case "SE":
            dados.uf = "Sergipe";
            break;
          case "TO":
            dados.uf = "Tocantins";
            break;
        }

        $.ajax({
          type: "GET", //rest Type
          dataType: "json", //mispelled
          url:
            "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" +
            $cep +
            "&shipping_address%5Bcountry%5D=" +
            "Brazil" +
            "&shipping_address%5Bprovince%5D=" +
            dados.uf,
          beforeSend: function () {
            //$('.overlay-carregando').show();
          },
          success: function (msg) {
            $shipping_list.html("");
            // $ship_name_display.html(msg.shipping_rates[0].name);
            // if($('.shipping-display.value') === 0.00){
            //   $('.shipping-display.value').html("Grátis");
            // }else{
            //   $('.shipping-display.value').html(Shopify.formatMoney(msg.shipping_rates[0].price, window.money_format));
            // }
            for (i = 0; i < msg.shipping_rates.length; i++) {
              var deliveryDate = msg.shipping_rates[i].delivery_date;

              var entrega = new Date(msg.shipping_rates[i].delivery_date);
              var checkBeforeday = isDateBeforeToday(entrega);
              var excludeDateCheck = excludeDate(msg.shipping_rates[i].name);
              let dataFormatada =
                entrega.getDate() +
                "/" +
                (entrega.getMonth() + 1) +
                "/" +
                entrega.getFullYear();

              let $formatedPrice;
              let $estimateShip;
              if (msg.shipping_rates[i].price === 0.0) {
                $formatedPrice = "Grátis";
              } else {
                $formatedPrice = Shopify.formatMoney(
                  msg.shipping_rates[i].price,
                  window.money_format
                );
              }
              var $priceShip = msg.shipping_rates[i].price;
              if (
                msg.shipping_rates[i].delivery_days[1] == null ||
                msg.shipping_rates[i].delivery_days[1] === 0
              ) {
                $estimateShip = "";
              } else {
                $estimateShip =
                  "Em até " +
                  msg.shipping_rates[i].delivery_days[1] +
                  " dias úteis";
              }

              if (
                (deliveryDate == null && excludeDateCheck) ||
                (checkBeforeday && excludeDateCheck)
              ) {
                entrega = "Estimativa de entrega indisponível";
              } else if (!excludeDateCheck) {
                if (
                  d.shipping_rates[i].name ==
                  "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis"
                ) {
                  entrega = "";
                } else {
                  entrega = "";
                }
              } 
              else {
                entrega = "<br/>(Estimativa de entrega: " + dataFormatada + ")";
              }
              // else {
              //   entrega = "";
              // }

              var $template =
                '<li data-shipping-change class="filters-group__list__item"> <label for="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" class="filters-checkbox"> <input type="radio" name="shipping_id" value="shippingId" id="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" data-name="' +
                msg.shipping_rates[i].name +
                '" data-price="' +
                msg.shipping_rates[i].price +
                '" data-formatted-price="' +
                $formatedPrice +
                '" data-delivery="' +
                $estimateShip +
                '"> <span class="check"></span> <span class="text" style="text-align: right;display: block;">' +
                $formatedPrice +
                " " +
                //entrega +
                "(" + $estimateShip + ")" +
                "</span> </label> </li>";

              $shipping_list.append($template);

              //$("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
              $btn_calc.removeClass("is-loading");
            }
            // $display_shipping.removeClass('hidden');
            // $ship_name_display.removeClass('hidden');
            $shipping_list_container.removeClass("hidden");
          },
          error: function (erro) {
            error_ship_ajax("Não encontrou um frete?");
            $btn_calc.removeClass("is-loading");
          },
        });
      }
    );
  }

  function select_ship(selected) {
    var name = selected.data("name"),
      price = selected.data("price"),
      formated_price = selected.data("formatted-price"),
      delivery = selected.data("delivery");

    var $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $ship_price_display = $(".shipping-display.value"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping");

    $ship_name_display.html(name);
    $ship_price_display.html(formated_price);

    $display_shipping.removeClass("hidden");
    $ship_name_display.removeClass("hidden");
    $shipping_list_container.addClass("hidden");
    $btn_calc.addClass("hidden");
    $btn_change.removeClass("hidden");
  }

  function show_rate_list() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options");
    $shipping_list_container.removeClass("hidden");
  }

  function reset_ship() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping"),
      $input_cep = $(".zipcode-input");

    $shipping_list_container.addClass("hidden");
    $display_shipping.addClass("hidden");
    $btn_change.addClass("hidden");
    $btn_calc.removeClass("hidden");
    $input_cep.val("").focus();
  }

  $(document).on("click", ".calculate-shipping", function (e) {
    shipping_ajax();
  });

  $(document).on("click", ".recalculate-shipping", function (e) {
    reset_ship();
  });

  $(document).on("click", "[data-shipping-change]", function (e) {
    select_ship($(this).find("input"));
  });

  $(document).on("click", ".show-rates-list", function (e) {
    show_rate_list();
  });
})(jQuery);
